import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useForm } from "react-hook-form";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useSnackbar } from "notistack";
import jwt_decode from "jwt-decode";

export default function LoginSeeker() {
  const { isAuthenticated, userLogin, socialLogin } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const [showPass, setShowPass] = useState(false);
  const [googleClientId, setGoogleClientId] = useState(null);
  const history = useHistory();

  const { register, handleSubmit, errors } = useForm();

  useEffect(() => {
    // Fetch social config from backend
    let isMounted = true;
    const controller = new AbortController();
    
    axios.get("/api/portal/social-config", { signal: controller.signal })
      .then(response => {
        if (!isMounted) return;
        if (response.data.status === "success") {
          setGoogleClientId(response.data.data.google_client_id);
          console.log("Social config loaded successfully");
        }
      })
      .catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load social config:", error);
        }
      });

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      history.push("/profile?tab=dashboard");
    }
  }, [isAuthenticated]);

  const onSubmit = (value) => {
    userLogin({
      type: "seeker",
      email: value.email,
      password: value.password,
    });
  };

  const handleGoogleSuccess = (credentialResponse) => {
    const decodedToken = jwt_decode(credentialResponse.credential);
    socialLogin({
      provider: "google",
      type: "seeker",
      email: decodedToken.email,
      name: decodedToken.name,
      socialid: decodedToken.sub,
      token: credentialResponse.credential,
    });
  };

  return (
    <div className="section-full p-t60 p-b0 bg-white">
    
        <div className="row">
          {/* ── Image panel (appears LEFT via CSS order) ── */}
          <div className="col-xl-6 col-lg-6 col-md-12">
            <figure className="account-image">
              <img src="/portal/images/LoginBGImg-Photoroom.png" alt="info image" />
            </figure>
          </div>
          {/* ── Form panel (appears RIGHT via CSS order) ── */}
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="twm-log-reg-form-wrap">

              <h2 className="wt-title">Welcome to Solid Future</h2>
              <p className="twm-log-reg-subtitle">
                Boost your hiring success with a streamlined and user friendly job application system.
              </p>

              <div className="radio_tabs">
                <ul>
                  <li className="active">
                    <Link to="/login-seeker">
                      <input type="radio" name="radiotab" checked />Login
                    </Link>
                  </li>
                  <li >
                    <Link to="/register-seeker">
                      <input type="radio" name="radiotab" />Register
                    </Link>
                  </li>
                </ul>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                {/* Email */}
                <input type="hidden" name="type" value="seeker" ref={register()}/>
                <div className="form-group mb-3">
                  <label className="twm-field-label">Email</label>
                  <input
                    name="email"
                    type="email"
                    required
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    ref={register({
                      required: "Email field is required.",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.email && <div className="text-danger">{errors.email.message}</div>}
                </div>

                {/* Password */}
                <div className="form-group mb-3 position-relative" id="login-passwords-group">
                  <label className="twm-field-label">Password</label>
                  <input
                    name="password"
                    type={showPass ? "text" : "password"}
                    id="login-passwords"
                    required
                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                    ref={register({ required: "Password field is required" })}
                  />
                  <span
                    className="showPassword"
                    onClick={() => setShowPass(!showPass)}
                  >
                    <i className={showPass ? "ri-eye-off-fill" : "ri-eye-fill"}></i>
                  </span>
                  {errors.password && <div className="text-danger">{errors.password.message}</div>}
                </div>

                {/* Remember me + Forgot Password */}
                <div className="form-group mb-3 twm-rem-forgot">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="remember_me"
                      name="remember"
                      defaultValue="Y"
                      ref={register()}
                    />
                    <label className="form-check-label" htmlFor="remember_me">
                      Remember me
                    </label>
                  </div>
                  <Link to="/forgot-password-seeker" className="site-text-primary">
                    Forgot Password?
                  </Link>
                </div>

                <button type="submit" className="site-button">Login</button>
              </form>

              {/* OR divider */}
              <div className="twm-or-divider">OR Login Via</div>

              {/* Social icons */}
              <ul className="twm-modal-social">
                <li>
                  {googleClientId && (
                    <GoogleOAuthProvider clientId={googleClientId}>
                      <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={() => enqueueSnackbar("Google login failed", { variant: "error" })}
                        theme="outline"
                        size="large"
                      />
                    </GoogleOAuthProvider>
                  )}
                </li>
              </ul>

              {/* Register link */}
              <p className="twm-new-register">
                New To Solid Future?{" "}
                <Link to="/register-seeker" className="site-text-primary">Register</Link>
              </p>

            </div>
          </div>
        </div>
   
    </div>
  );
}
